import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { Link } from "react-router-dom";
// import FooterLogo from "../../assets/g2i-logo.svg";
import { IconButton, MenuItem, Select } from "@mui/material";
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";

const Footer: React.FC = () => {
  return (
    <Box
      sx={{
        padding: "40px 20px",
        backgroundColor: "#290854",
        color: "#fff",
        textAlign: "center",
      }}
    >
      <Grid container spacing={3} justifyContent="center">
        <Grid item xs={12} sm={6} md={3}>
          <Typography
            variant="h5"
            sx={{ marginBottom: "20px", fontWeight: "bold" }}
          >
            Explore
          </Typography>
          <Box sx={{ display: "flex", flexDirection: "column", gap: "15px" }}>
            <Link to="/" style={{ color: "#ccc", textDecoration: "none" }}>
              Home
            </Link>
            <Link
              to="/contact-us"
              style={{ color: "#ccc", textDecoration: "none" }}
            >
              Contact Us
            </Link>
            <Link
              to="/about-us"
              style={{ color: "#ccc", textDecoration: "none" }}
            >
              About Us
            </Link>
          </Box>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Typography
            variant="h5"
            sx={{ marginBottom: "20px", fontWeight: "bold" }}
          >
            Courses
          </Typography>
          <Box sx={{ display: "flex", flexDirection: "column", gap: "15px" }}>
            <Link
              to="/courses"
              style={{ color: "#ccc", textDecoration: "none" }}
            >
              ReactJS
            </Link>
            <Link
              to="/courses"
              style={{ color: "#ccc", textDecoration: "none" }}
            >
              NodeJS
            </Link>
            <Link
              to="/courses"
              style={{ color: "#ccc", textDecoration: "none" }}
            >
              UI/UX
            </Link>
          </Box>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Typography
            variant="h5"
            sx={{ marginBottom: "20px", fontWeight: "bold" }}
          >
            Company
          </Typography>
          <Box sx={{ display: "flex", flexDirection: "column", gap: "15px" }}>
            <Link
              to="/careers"
              style={{ color: "#ccc", textDecoration: "none" }}
            >
              Careers
            </Link>
            <Link to="/blogs" style={{ color: "#ccc", textDecoration: "none" }}>
              Blog
            </Link>
            <Link to="/press" style={{ color: "#ccc", textDecoration: "none" }}>
              Press
            </Link>
          </Box>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Typography
            variant="h5"
            sx={{ marginBottom: "20px", fontWeight: "bold" }}
          >
            Follow Us
          </Typography>
          <Box sx={{ display: "flex", justifyContent: "center", gap: "10px" }}>
            <IconButton
              color="inherit"
              component="a"
              href="https://facebook.com"
            >
              <FacebookIcon />
            </IconButton>
            <IconButton
              color="inherit"
              component="a"
              href="https://twitter.com"
            >
              <TwitterIcon />
            </IconButton>
            <IconButton
              color="inherit"
              component="a"
              href="https://linkedin.com"
            >
              <LinkedInIcon />
            </IconButton>
            <IconButton
              color="inherit"
              component="a"
              href="https://instagram.com"
            >
              <InstagramIcon />
            </IconButton>
          </Box>
        </Grid>
      </Grid>

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "50px",
          marginTop: "40px",
          flexDirection: { xs: "column", md: "row" },
        }}
      >
        <Box>
          <img src="/assets/G2i-footer.svg" alt="Logo" style={{ width: "90px" }} />
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "20px",
            marginTop: { xs: "20px", md: "0" },
            flexDirection: { xs: "column", md: "row" },
          }}
        >
          <Typography sx={{ marginBottom: { xs: "10px", md: "0" } }}>
            <Link
              to="/privacy-policy"
              style={{ color: "#fff", textDecoration: "none" }}
            >
              Privacy Policy
            </Link>
          </Typography>
          <Typography sx={{ marginBottom: { xs: "10px", md: "0" } }}>
            <Link
              to="/terms-conditions"
              style={{ color: "#fff", textDecoration: "none" }}
            >
              Terms & Conditions
            </Link>
          </Typography>
          <Typography>
            <Link
              to="/copyright-notification"
              style={{ color: "#fff", textDecoration: "none" }}
            >
              Copyright Notification
            </Link>
          </Typography>
        </Box>
      </Box>

      <Typography
        variant="body2"
        sx={{ marginTop: "20px", fontSize: "0.875rem" }}
      >
        &copy;{new Date().getFullYear()} Global Genius Index. All rights
        reserved.
      </Typography>
    </Box>
  );
};

export default Footer;
